export default __webpack_public_path__ + "static/Natural_Light_Indoor-d3844420ed810f963a3e53ee7d61e10d.avif";